import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8kumxdqk: FaireBrandEntity = {
  token: "b_8kumxdqk",
  type: "brand",
  name: "Paper Cow LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/50a61197aaa43134f3a4763cf4c9dfcaea0f42da04b0673f1c27d35302cbd5b6.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/3610dfe1bd31cbb05326137e8856195f86b2fed2feb3a9c8249dff674b308ba2.png",
  logoUrl:
    "https://cdn.faire.com/fastly/50a61197aaa43134f3a4763cf4c9dfcaea0f42da04b0673f1c27d35302cbd5b6.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3610dfe1bd31cbb05326137e8856195f86b2fed2feb3a9c8249dff674b308ba2.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 104,
  rating: 4.9,
  reviewCount: 117,
  isTopShop: true,
  isInsider: true,
  description:
    "Hi!!  My name is Cassie and I am an apparel designer/artist.  I started this line about 8 years ago after leaving my full time job in the fashion industry.  We have shipped to over 1000+ boutiques across the country and we sell at local markets and fairs on the weekends. I came up with the name Paper Cow for two reasons: To let our audience know our graphics are hand drawn, making it a true handmade product. And because the cow quickly became the stand-out character as I was sketching the animals.  The line started out with just 4 animals and expanded from there!   We also do quite a bit of custom items for our shops including youth and adult sizing by special request...We love working with you on whatever your shop may need!\n\nI currently live in Los Angeles with my husband and 3 kids including twins!  Please do not hesitate to reach out with any questions or comments-we love hearing from you! :)\n\n*Please note that products are designed/screen printing in Los Angeles.  The blanks are made in India & Indonesia (some items have USA made components too).  ",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:09.335Z",
    importedBy: "entity-db-cli",
  },
};
